import { Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Preview.css';
import { ImageNone } from '../ImageNone';

interface IPreviewProps {
  previewImage: string;
  previewAvatarNode: React.ReactNode;
  isOffer: boolean;
}

export const Preview: React.FC<IPreviewProps> = ({ previewImage, previewAvatarNode, isOffer }) => (
  <div className={styles['preview']}>
    {previewImage ? (
      <Image width={60} height={60} borderRadius="4px" objectFit="cover" src={previewImage} />
    ) : (
      <ImageNone type={isOffer ? 'offer' : 'agent'} />
    )}
    {previewAvatarNode && <div className={styles['preview_overlay']} />}
    {previewAvatarNode && <div className={styles['preview_avatar']}>{previewAvatarNode}</div>}
  </div>
);
